export const payment = {
  title: 'Payment Method',
  card: 'Card',
  eps: 'EPS',
  giropay: 'Giropay',
  card_number: 'Card number',
  expiry: 'Expiry',
  cvc: 'CVC',
  country: 'Country',
  postal_code: 'Postal code',
  next: 'Next',
  countries: {
    us: 'United States',
    fr: 'France',
    de: 'Germany',
  },
}
